import { useState } from "react";
import { Modal, Nav } from "react-bootstrap";
import UserManagementTable from "./UserManagementTable";
import BulkAddMemberManagement from "../../usermanagement/BulkAddMemberManagement";
import MemberBulkUpload from "../../usermanagement/MemberBulkUpload";

function ContentUserManagementDetailsNew() {
  const [totalAdminUsersData, setTotalAdminUsersData] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState("admin");

  const totalAdminUserData = (data) => {
    setTotalAdminUsersData(data);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row align-items-center pb-3 sticky-top-bar">
          <div className="col-md">
            <h4 className="mb-0 content-main-title">User Management</h4>
          </div>

          <div className="col-md text-end">
            <button
              onClick={() => setShowModal(true)}
              className="btn btn-primary add-new-program-btn"
            >
              <i className="bi bi-person-plus-fill me-2"></i> Add New User
            </button>
          </div>
        </div>

        <div className="row align-items-center pb-3">
          <div className="reports-programs">
            <div className="row align-items-center">
              <div className="col-md-auto">
                <img
                  src="https://storage.googleapis.com/ksabupatest/dashboardresources/icons/usermanagement.png"
                  alt="icon"
                  style={{ height: "140px" }}
                />
              </div>
              <div className="col-md">
                <p className="mb-0">
                  The User Management module allows admins to easily add or
                  remove users.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="row align-items-center pb-3">
          <div className="comntent-UserManagement mb-3">
            <div className="table-responsive tableUserManagement">
              <UserManagementTable
                setTotalAdminUsersData={totalAdminUserData}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">Add New User</Modal.Title>
        </Modal.Header>

        {/* Tab Navigation */}
        <div className="border-bottom px-3 pt-2">
          <Nav className="nav nav-tabs" role="tablist">
            <Nav.Item>
              <Nav.Link
                active={activeTab === "admin"}
                onClick={() => setActiveTab("admin")}
                className={`nav-link ${activeTab === "admin" ? "active" : ""}`}
              >
                Admin Upload
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                active={activeTab === "member"}
                onClick={() => setActiveTab("member")}
                className={`nav-link ${activeTab === "member" ? "active" : ""}`}
              >
                Member Upload
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </div>

        <Modal.Body>
          <div className="tab-content">
            {activeTab === "admin" && (
              <div className="tab-pane fade show active">
                <BulkAddMemberManagement />
              </div>
            )}
            {activeTab === "member" && (
              <div className="tab-pane fade show active">
                <MemberBulkUpload />
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ContentUserManagementDetailsNew;
